import React from 'react';
import TicketDetailComp from '../../components/portal/TicketDetail';

const TicketDetail = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold mb-6">Ticket Details</h1>
      <TicketDetailComp />
    </div>
  );
};

export default TicketDetail; 